import { useContext, useMemo } from 'react';
import dynamic from 'next/dynamic';
import cn from 'classnames';
import { LanguageContext } from 'context/Language';
import { activeLocales, defaultLocale, locales } from 'context/Dictionary';
import DictionaryContext from 'context/Dictionary/DictionaryContext';
import { useTranslation } from 'hooks';
import { keys } from 'utils';
import { Check } from 'resources';

const Icon = dynamic(() => import('components/Icon'));

export interface Alternative {
  title: string;
}

interface Props {
  isMobile?: boolean;
  closeSwitcher?: (value) => void;
}

const LanguageSwitcher: React.FC<Props> = ({ isMobile, closeSwitcher }) => {
  const { t } = useTranslation(['header']);
  const { lang } = useContext(LanguageContext);
  const { activeLanguages } = useContext(DictionaryContext);

  const alternatives = useMemo(() => {
    return locales
      .filter((locale) => activeLanguages?.includes(locale))
      .reduce(
        (acc, current) => ({
          ...acc,
          [current]: {
            title: t(current),
            // link: `${process.env.HOST}${getAsPathname(route, { ...query, lang: current })}`,
          },
        }),
        {} as Record<typeof defaultLocale, Alternative>,
      );
    //deps asPath
  }, [activeLanguages]);

  const changeCurrentLanguage = (key: string) => {
    if (window?.location.pathname.split(`/${lang}/`)[1] !== undefined) {
      window?.location?.replace(
        `${window?.location?.origin}/${key}/${window?.location.pathname.split(`/${lang}/`)[1]}`,
      );
    } else {
      window?.location?.replace(`${window?.location?.origin}/${key}`);
    }
    if (closeSwitcher !== undefined) {
      closeSwitcher(false);
    }
  };

  return (
    <ul className="language-switcher-tooltip">
      {keys(alternatives)
        .filter((key) => isMobile || key !== lang)
        .map((key, i) => (
          <li
            key={i}
            className="language-switcher-tooltip__item"
            onClick={() => changeCurrentLanguage(key as string)}
          >
            <a className={cn({ 'is-active': key === lang })}>
              {isMobile && key === lang && <Icon component={Check} />} {alternatives[key].title}
            </a>
          </li>
        ))}
    </ul>
  );
};

export default LanguageSwitcher;
